import meta from './meta.json'
const modules = import.meta.glob('../pages/**/*.vue')
// Lazy load route
function route(path, component, name) {
  const match = modules[`../pages/${component}.vue`]
  return {
    path,
    name: name || component,
    component: match, //() => import(`@/pages/${component}.vue`),
    meta: meta[path]
  }
}

export default [
  route('/', 'Home'),
  route('/user', 'user/AccountSettings'),
  route('/email_alerts', 'user/EmailAlerts'),
  route('/email_alerts/create', 'user/EmailAlertsCreateEdit', 'CreateEmailAlert'),
  route('/email_alerts/edit/:id', 'user/EmailAlertsCreateEdit', 'EditEmailAlert'),
  route('/groups', 'user/FundGroups'),
  route('/groups/create', 'user/FundGroupsCreateEdit', 'CreateFundGroup'),
  route('/groups/edit/:id', 'user/FundGroupsCreateEdit', 'EditFundGroup'),
  route('/watchlists', 'user/StockWatchLists'),
  route('/watchlists/create', 'user/StockWatchListCreateEdit', 'CreateWatchList'),
  route('/watchlists/edit/:id', 'user/StockWatchListCreateEdit', 'EditWatchList'),
  route('/tracked_backtests/:id?', 'user/TrackedBacktests'),
  route('/insider_dashboard', 'InsiderDashboard'),
  route('/insider_backtester/:id?', 'InsiderBacktester'),
  route('/whale_trader/:id?', 'WhaleBacktester'),
  route('/whale_screener/:id?', 'WhaleScreener'),
  route('/trend_finder/:id?', 'other/TrendFinder'),
  // Analytics
  route('/analytics/backtester/:id?', 'analytics/Backtester'),
  route('/analytics/consensus/:id?', 'analytics/Consensus'),
  route('/analytics/combined/:id?', 'analytics/Combined'),
  route('/analytics/double_down', 'analytics/DoubleDown'),
  route('/analytics/overlapping_matrix', 'analytics/OverlapMatrix'),
  route('/analytics/early_bird_screener', 'analytics/EarlyBird'),
  // Search
  route('/search/fund_performance_search', 'search/FundPerformanceSearch'),
  route('/search/fund_search', 'search/BiSearch'),
  route('/search/stock_screener', 'search/StockScreener'),
  route('/search/sector_search', 'search/SectorSearch'),
  route('/search/options_search', 'search/OptionsSearch'),
  route('/global/global_search', 'global/GlobalHoldingSearch'),
  route('/global/organization/:id', 'global/Organization'),
  route('/global/instrument/:id', 'global/Instrument'),
  route('/short/short_dashboard', 'short/ShortDashboard'),
  route('/short/short_position_holder/:id?', 'short/ShortPositionHolder'),
  route('/short/short_position_issuer/:id?', 'short/ShortPositionIssuer'),
  // Other
  route('/other/schedule13', 'other/Schedule13Search'),
  route('/other/uk_search', 'other/LseTransactions'),
  route('/other/hkex_search', 'other/HkexTransactions'),
  route('/other/form_adv_search', 'other/AdvisorSearch'),
  route('/other/form_d_search', 'other/FormDSearch'),
  route('/other/form144_search', 'other/Form144Search'),
  route('/other/nsar_search', 'other/NsarSearch'),
  route('/other/ncen_search', 'other/NcenSearch'),
  route('/mutual_fund/ncen_search', 'other/NcenSearch'),
  route('/other/form4_search', 'other/Form4Search'),
  route('/mutual_fund/portfolio_similarity', 'mutual_fund/PortfolioSimilarity'),
  // mutual fund
  route('/mutual_fund/mutual_fund_view/:id', 'mutual_fund/MutualFundView'),
  route('/mutual_fund/mutual_fund_holdings_view/:id', 'mutual_fund/MutualFundHoldingsView'),
  route('/mutual_fund/combined_mutual_fund/:id?', 'mutual_fund/CombinedMutualFund'),
  route('/congress/congress_person_view/:id', 'congress/CongressPersonView'),
  route('/congress/congressional_transactions', 'congress/CongressTransactions'),
  route('/congress/congress_person_search', 'congress/CongressSearch'),
  // Global redirect for 404
  route('/404', '404'),
  { path: '/:pathMatch(.*)*', redirect: '/404' }
]
